export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** An `ObjectId` is a unique hexadecimal string of 12 bytes containing a timestamp, random value and a sequential counter. For example `507f191e810c19729de860ea` */
  ObjectId: any;
  /** A mobile or fixed phone number, including a country prefix. For example `+32477875642` */
  PhoneNumber: any;
};

/** Describes a place using it's address */
export type AddressInputObjectType = {
  id: Scalars['String'];
  street: Scalars['String'];
  streetNumber: Scalars['String'];
  zipcode: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  country: CountryEnum;
  longitude: Scalars['Float'];
  latitude: Scalars['Float'];
};

/** Describes a place using it's address */
export type AddressObjectType = {
  __typename?: 'AddressObjectType';
  id: Scalars['String'];
  street: Scalars['String'];
  streetNumber: Scalars['String'];
  zipcode: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  country: CountryEnum;
  longitude: Scalars['Float'];
  latitude: Scalars['Float'];
};

/** A list of all possible allergens */
export enum AllergensEnumType {
  /** Product contains peanuts */
  Peanuts = 'peanuts',
  /** Product contains nuts */
  Nuts = 'nuts',
  /** Product contains crustaceans (a type of shellfish) */
  Crustaceans = 'crustaceans',
  /** Product contains molluscs (a type of shellfish) */
  Molluscs = 'molluscs',
  /** Product contains fish */
  Fish = 'fish',
  /** Product contains eggs */
  Eggs = 'eggs',
  /** Product contains milk */
  Milk = 'milk',
  /** Product contains gluten */
  Gluten = 'gluten',
  /** Product contains soya */
  Soya = 'soya',
  /** Product contains sesame seeds */
  Sesame = 'sesame',
  /** Product contains celery */
  Celery = 'celery',
  /** Product contains mustard */
  Mustard = 'mustard',
  /** Product contains lupin */
  Lupin = 'lupin',
  /** Product contains sulphur dioxide */
  SulphurDioxide = 'sulphurDioxide'
}

/** Describes an announcement */
export type AnnouncementInputObjectType = {
  title: Scalars['String'];
  content: Scalars['String'];
};

/** Describes an announcement */
export type AnnouncementObjectType = {
  __typename?: 'AnnouncementObjectType';
  _id: Scalars['ObjectId'];
  title: Scalars['String'];
  content: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

/** Describes an api key */
export type ApiKeyObjectType = {
  __typename?: 'ApiKeyObjectType';
  _id: Scalars['ObjectId'];
  name: Scalars['String'];
  token: Scalars['String'];
  lastUsed: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type ApiKeyPaginatedResultObjectType = {
  __typename?: 'ApiKeyPaginatedResultObjectType';
  /** Documents */
  docs: Array<ApiKeyObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Type of account used for authentication */
export enum AuthTypeEnum {
  Api = 'api',
  User = 'user'
}

/** Information about a billing log. */
export type BillingLogObjectType = {
  __typename?: 'BillingLogObjectType';
  _id: Scalars['ObjectId'];
  companyName: Scalars['String'];
  vatNumber: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  reference: Scalars['String'];
  organisationId: Scalars['ObjectId'];
  organisation?: Maybe<OrganisationObjectType>;
  removeAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

/** A box is a a single box within a locker */
export type BoxObjectType = {
  __typename?: 'BoxObjectType';
  /** A sequential numeric id that is unique within the locker */
  id: Scalars['Int'];
  lockStatus: LockStatusEnum;
  pincode: Scalars['String'];
  language: Scalars['String'];
  /** The reservation that should currently be or end up in the locker */
  reservation?: Maybe<ReservationObjectType>;
};

/** An object describing the box that has been reserved for a reservation */
export type BoxReservationInputObjectType = {
  /** The internal id linking to the locker this reservation is created for. */
  lockerId: Scalars['ObjectId'];
  /** The numeric id of the box this reservation occupies. */
  boxId: Scalars['Int'];
};

/** An object describing the box that has been reserved for a reservation */
export type BoxReservationObjectType = {
  __typename?: 'BoxReservationObjectType';
  /** The internal id linking to the locker this reservation is created for. */
  lockerId: Scalars['ObjectId'];
  /** The locker this reservation is created for. */
  locker?: Maybe<LockerObjectType>;
  /** The numeric id of the box this reservation occupies. */
  boxId: Scalars['Int'];
  /** Name of the locker, used as a public version of locker data. */
  lockerName?: Maybe<Scalars['String']>;
};

/** Data Type for updating branding settings. */
export type BrandingSettingsInputObjectType = {
  brandColor: Scalars['String'];
  /**
   * A google storage file key where the image is stored, for further processing
   * and linking (this has to be in the upload bucket of viresmo)
   */
  logoObjectKey?: Maybe<Scalars['String']>;
};

/** Lock Status, open or closed */
export enum ConnectionStatusEnum {
  /** Device is online */
  Online = 'Online',
  /** Device is offline */
  Offline = 'Offline'
}

/** Country */
export enum CountryEnum {
  Be = 'be',
  Nl = 'nl',
  Fr = 'fr',
  De = 'de',
  At = 'at'
}

/** Data needed to create a new customer. */
export type CreateCustomerInputObjectType = {
  /**
   * External id used for linking an internal customer to an external datasource,
   * usually this is the e-commerce or ERP system used by the company.
   */
  externalId?: Maybe<Scalars['String']>;
  /** A dedicated pincode for the customer, so they can always pickup their order using the same pincode. */
  pincode?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  emails?: Maybe<Array<Scalars['String']>>;
  phonenumbers?: Maybe<Array<Scalars['PhoneNumber']>>;
  language?: LanguageEnum;
  shopId: Scalars['ObjectId'];
};

/** Data required to create/connect a locker */
export type CreateLockerInputObjectType = {
  temperatureType: LockerTemperatureTypeEnum;
  serviceLocationId: Scalars['ObjectId'];
  boxCount?: Scalars['Int'];
  name?: Scalars['String'];
  shopId: Scalars['ObjectId'];
};

/** Data required to create a reservation */
export type CreateReservationInputObjectType = {
  /** The time the reservation is planned for pickup */
  pickupDateTime: Scalars['DateTime'];
  /** An optional external id to identify the order, mainly used for integrating with 3rd party platforms */
  externalOrderId?: Maybe<Scalars['String']>;
  /** An optional id pointing to a linked order */
  orderId?: Maybe<Scalars['ObjectId']>;
  /** A 4 character numeric pincode used for opening the locker at pickup */
  pincode?: Maybe<Scalars['String']>;
  /** If true and the reservation has been picked up this locker will remain reserved untill manually completed. */
  noAutoComplete?: Scalars['Boolean'];
  /** If true and the reservation has reach the configured time before pickup, we will automatically send a notification. */
  automaticallySendNotification?: Scalars['Boolean'];
  /** The notifications that should be dispatched x amount of time before pickup. */
  notificationTypes?: Array<Maybe<NotificationTypeEnumType>>;
  /** Information about the reservation, this is usually a description of the content. */
  extraInformation?: Maybe<Scalars['String']>;
  /**
   * The internal id of the customer this reservation belongs to. If none is
   * provided, contact information is required and we will automatically try to
   * link a customer using this information or create one if there is none.
   */
  customerId?: Maybe<Scalars['ObjectId']>;
  /** The first name of the customer, defaults to the customer first name if a customer id is provided. */
  firstName?: Maybe<Scalars['String']>;
  /** The last name of the customer, defaults to the customer last name if a customer id is provided. */
  lastName?: Maybe<Scalars['String']>;
  /** The emails of the customer, defaults to the customer email if a customer id is provided. */
  emails?: Maybe<Array<Scalars['String']>>;
  /** The phonenumbers of the customer, defaults to the customer phonenumber if a customer id is provided. */
  phonenumbers?: Maybe<Array<Scalars['PhoneNumber']>>;
  /** The preferred language of the customer */
  language?: LanguageEnum;
  /** A list of vending product items */
  vendingProducts?: Array<ProductCollectionItemInputObjectType>;
  /** A discount percentage to apply to the vending total price, ex 500 => 5% */
  vendingDiscount?: Maybe<Scalars['Int']>;
  /** The total price of the reservation for vending purposes */
  vendingTotalPrice?: Maybe<Scalars['Int']>;
  /** Is reservation a vending reservation */
  isVendingReservation?: Maybe<Scalars['Boolean']>;
  /** Should customer still pay this reservation, this will send a pay link to the customer when box gets reserved. */
  shouldCustomerPay?: Maybe<Scalars['Boolean']>;
  /** Does this reservation contain food. */
  canUseMealVouchers?: Maybe<Scalars['Boolean']>;
  shopId: Scalars['ObjectId'];
};

export type CreateUserInputObjectType = {
  name: Scalars['String'];
  email: Scalars['String'];
  role: Scalars['Int'];
};

/** Describes the customer with all information needed for reservations. */
export type CustomerObjectType = {
  __typename?: 'CustomerObjectType';
  /** Internal id used for linking with other data-types and to quickly find the customer in the database. */
  _id: Scalars['ObjectId'];
  /** Numeric id used purely as a visual representation to the end-user */
  id: Scalars['Int'];
  /**
   * External id used for linking an internal customer to an external datasource,
   * usually this is the e-commerce or ERP system used by the company.
   */
  externalId?: Maybe<Scalars['String']>;
  /** A dedicated 5 character numeric pincode for the customer, so they can always pickup their order using the same pincode. */
  pincode?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  emails: Array<Scalars['String']>;
  phonenumbers: Array<Scalars['PhoneNumber']>;
  language: LanguageEnum;
  shopId: Scalars['ObjectId'];
  shop: ShopObjectType;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type CustomerPaginatedResultObjectType = {
  __typename?: 'CustomerPaginatedResultObjectType';
  /** Documents */
  docs: Array<CustomerObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Sort the results based on the value of this object */
export type CustomerSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: Maybe<SortEnumType>;
  /** Sort based on the value: id */
  id?: Maybe<SortEnumType>;
  /** Sort based on the value: externalId */
  externalId?: Maybe<SortEnumType>;
  /** Sort based on the value: firstName */
  firstName?: Maybe<SortEnumType>;
  /** Sort based on the value: lastName */
  lastName?: Maybe<SortEnumType>;
  /** Sort based on the value: emails */
  emails?: Maybe<SortEnumType>;
  /** Sort based on the value: phonenumbers */
  phonenumbers?: Maybe<SortEnumType>;
  /** Sort based on the value: updatedAt */
  updatedAt?: Maybe<SortEnumType>;
};

/** A range used to filter based on timestamps. */
export type DateRangeInputObjectType = {
  /** Filtered objects should fall after this date */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Filtered objects should fall before this date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Return items that fall before this date */
  lt?: Maybe<Scalars['DateTime']>;
  /** Return items that fall on or before this date */
  lte?: Maybe<Scalars['DateTime']>;
  /** Return items that fall after this date */
  gt?: Maybe<Scalars['DateTime']>;
  /** Return items that fall on or after this date */
  gte?: Maybe<Scalars['DateTime']>;
};


/** Filter dealers... */
export type DealerFilterInputObjectType = {
  resellerId?: Maybe<Scalars['ObjectId']>;
};

/** Information required to create or update an dealer. */
export type DealerInputObjectType = {
  companyName: Scalars['String'];
  registrationNumber: Scalars['String'];
  vatNumber: Scalars['String'];
  email: Scalars['String'];
  phonenumber: Scalars['PhoneNumber'];
  address: AddressInputObjectType;
  resellerId: Scalars['ObjectId'];
};

/** Information about a dealer. */
export type DealerObjectType = {
  __typename?: 'DealerObjectType';
  _id: Scalars['ObjectId'];
  /** External id used to identify a dealer, this id might get used for invoices and support */
  id: Scalars['Int'];
  companyName: Scalars['String'];
  registrationNumber: Scalars['String'];
  vatNumber: Scalars['String'];
  email: Scalars['String'];
  phonenumber: Scalars['PhoneNumber'];
  address: AddressObjectType;
  resellerId: Scalars['ObjectId'];
  reseller?: Maybe<ResellerObjectType>;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

/** The firmware versions of a specific device */
export type DeviceFirmwareVersionsObjectType = {
  __typename?: 'DeviceFirmwareVersionsObjectType';
  /** Firmware version of the gateway */
  gateway: Scalars['Int'];
  /** Firmware version of the keypad */
  keypad: Scalars['Int'];
  /** Firmware version of the locks */
  lock: Scalars['Int'];
};

export type DeviceLogFilterInputObjectType = {
  severity?: Maybe<SeverityEnumType>;
  deviceId?: Maybe<Scalars['String']>;
  type?: Maybe<DeviceLogTypeEnum>;
  operation?: Maybe<DeviceLogOperationEnum>;
  lockerId?: Maybe<Scalars['ObjectId']>;
  serviceLocationId?: Maybe<Scalars['ObjectId']>;
  shopId?: Maybe<Scalars['ObjectId']>;
};

/** This is a log originating from an mqtt device. */
export type DeviceLogObjectType = {
  __typename?: 'DeviceLogObjectType';
  _id: Scalars['ObjectId'];
  deviceId: Scalars['String'];
  type: DeviceLogTypeEnum;
  operation: DeviceLogOperationEnum;
  severity: SeverityEnumType;
  errorCode?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  serviceLocationId: Scalars['ObjectId'];
  serviceLocation?: Maybe<ServiceLocationObjectType>;
  lockerId?: Maybe<Scalars['ObjectId']>;
  locker?: Maybe<LockerObjectType>;
  shopId: Scalars['ObjectId'];
  shop?: Maybe<ShopObjectType>;
  temperature?: Maybe<Scalars['Float']>;
  removeAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
};

/** The operation executed on or by the device */
export enum DeviceLogOperationEnum {
  State = 'State',
  Error = 'Error',
  LockerState = 'LockerState',
  RequestLockerConfig = 'RequestLockerConfig',
  TerminalAction = 'TerminalAction',
  RequestLatestVersion = 'RequestLatestVersion',
  Unknown = 'Unknown',
  GatewayConfigUpdate = 'GatewayConfigUpdate',
  LockerUpdate = 'LockerUpdate',
  OpenLocks = 'OpenLocks',
  ForceUpdate = 'ForceUpdate',
  LatestVersion = 'LatestVersion'
}

export type DeviceLogPaginatedResultObjectType = {
  __typename?: 'DeviceLogPaginatedResultObjectType';
  /** Documents */
  docs: Array<DeviceLogObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Sort the results based on the value of this object */
export type DeviceLogSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: Maybe<SortEnumType>;
  /** Sort based on the value: deviceId */
  deviceId?: Maybe<SortEnumType>;
  /** Sort based on the value: errorCode */
  errorCode?: Maybe<SortEnumType>;
  /** Sort based on the value: type */
  type?: Maybe<SortEnumType>;
  /** Sort based on the value: operation */
  operation?: Maybe<SortEnumType>;
  /** Sort based on the value: severity */
  severity?: Maybe<SortEnumType>;
  /** Sort based on the value: temperature */
  temperature?: Maybe<SortEnumType>;
};

/** The type of device log */
export enum DeviceLogTypeEnum {
  Command = 'Command',
  Event = 'Event'
}

/** Type of account used for authentication */
export enum FirmwareTypeEnum {
  GatewayV1 = 'GatewayV1',
  LockControllerV1 = 'LockControllerV1',
  PinpadControllerV1 = 'PinpadControllerV1'
}

/** Describes a Firmware Version. */
export type FirmwareVersionObjectType = {
  __typename?: 'FirmwareVersionObjectType';
  /** Internal id used for linking with other data-types and to quickly find the firmware version in the database. */
  _id: Scalars['ObjectId'];
  /** Type of firmware this object describes. */
  type: FirmwareTypeEnum;
  /** Version number of the firmware */
  version: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type FirmwareVersionPaginatedResultObjectType = {
  __typename?: 'FirmwareVersionPaginatedResultObjectType';
  /** Documents */
  docs: Array<FirmwareVersionObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Sort the results based on the value of this object */
export type FirmwareVersionSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: Maybe<SortEnumType>;
  /** Sort based on the value: type */
  type?: Maybe<SortEnumType>;
  /** Sort based on the value: version */
  version?: Maybe<SortEnumType>;
  /** Sort based on the value: updatedAt */
  updatedAt?: Maybe<SortEnumType>;
};

/** A range used to filter on a numeric value (Float). */
export type FloatRangeInputObjectType = {
  /** Return items that are lesser than the specified value */
  lt?: Maybe<Scalars['Float']>;
  /** Return items that are lesser than or equal to the specified value */
  lte?: Maybe<Scalars['Float']>;
  /** Return items that are greater than the specified value */
  gt?: Maybe<Scalars['Float']>;
  /** Return items that are greater than or equal to the specified value */
  gte?: Maybe<Scalars['Float']>;
};

/** A range used to filter on a numeric value (Integer). */
export type IntRangeInputObjectType = {
  /** Return items that are lesser than the specified value */
  lt?: Maybe<Scalars['Int']>;
  /** Return items that are lesser than or equal to the specified value */
  lte?: Maybe<Scalars['Int']>;
  /** Return items that are greater than the specified value */
  gt?: Maybe<Scalars['Int']>;
  /** Return items that are greater than or equal to the specified value */
  gte?: Maybe<Scalars['Int']>;
};

/** Language */
export enum LanguageEnum {
  Nl = 'nl',
  Fr = 'fr',
  En = 'en',
  De = 'de'
}

/** An Object that represent a string in a certain language. */
export type LocalisedStringInputObjectType = {
  /** The language of the string. */
  language: LanguageEnum;
  /** The value of the string. */
  value: Scalars['String'];
};

/** An Object that represent a string in a certain language. */
export type LocalisedStringObjectType = {
  __typename?: 'LocalisedStringObjectType';
  /** The language of the string. */
  language: LanguageEnum;
  /** The value of the string. */
  value: Scalars['String'];
};

/** Lock Status, open or closed */
export enum LockStatusEnum {
  /** Lock is open */
  Open = 'open',
  /** Lock is closed */
  Closed = 'closed'
}

/** A collection of pickup boxes, with additional metadata, future reservations and connectivity details */
export type LockerObjectType = {
  __typename?: 'LockerObjectType';
  _id: Scalars['ObjectId'];
  lockerId: Scalars['Int'];
  temperatureType: LockerTemperatureTypeEnum;
  /** Last measured temperature */
  temperature?: Maybe<LockerTemperatureObjectType>;
  /** List of the boxes that are part of the locker */
  boxes?: Maybe<Array<Maybe<BoxObjectType>>>;
  /**
   * Amount of boxes in the locker
   * @deprecated You can use boxes.length instead
   */
  boxCount: Scalars['Int'];
  /** Lockers Name */
  name: Scalars['String'];
  /** The status of the main door */
  mainDoorStatus: LockStatusEnum;
  /** Whether this locker is in lockdown or not, happens whenever something is broken or temperature is too low/high */
  isInLockdown: Scalars['Boolean'];
  /** An internal id linking to the service location this locker is located. */
  serviceLocationId: Scalars['ObjectId'];
  /** The service location this locker is located. */
  serviceLocation?: Maybe<ServiceLocationObjectType>;
  /** Indicates whether this locker is a test locker, test lockers do not have an attached device id. */
  isTestLocker: Scalars['Boolean'];
  /** Last time we received a state update for this locker */
  lastStateUpdateReceivedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  /** A list of reservations, currently in the locker. */
  activeReservations: Array<Maybe<ReservationObjectType>>;
  shopId: Scalars['ObjectId'];
  shop: ShopObjectType;
};


/** A collection of pickup boxes, with additional metadata, future reservations and connectivity details */
export type LockerObjectTypeBoxesArgs = {
  cooldown?: Maybe<Scalars['Int']>;
};

export type LockerPaginatedResultObjectType = {
  __typename?: 'LockerPaginatedResultObjectType';
  /** Documents */
  docs: Array<LockerObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** A temperature measure of a locker */
export type LockerTemperatureObjectType = {
  __typename?: 'LockerTemperatureObjectType';
  _id: Scalars['ObjectId'];
  lockerId: Scalars['ObjectId'];
  /** Temperature at this point in time */
  temperature: Scalars['Float'];
  removeAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

/** Locker type, defines temperature of locker */
export enum LockerTemperatureTypeEnum {
  /** Locker does not do any temperature control at all */
  NotCooled = 'NotCooled',
  /** Locker keeps room temperature (12-25°C) */
  RoomTemperature = 'RoomTemperature',
  /** Locker keeps refrigerator temperatures (3-6°C) */
  Refrigerated = 'Refrigerated',
  /** Locker keeps warm temperatures (60-80°C) */
  Heated = 'Heated'
}

export type LogFilterInputObjectType = {
  severity?: Maybe<SeverityEnumType>;
  operation?: Maybe<LogOperationEnum>;
  type?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['ObjectId']>;
  lockerId?: Maybe<Scalars['ObjectId']>;
  reservationId?: Maybe<Scalars['ObjectId']>;
  serviceLocationId?: Maybe<Scalars['ObjectId']>;
  productId?: Maybe<Scalars['ObjectId']>;
  orderId?: Maybe<Scalars['ObjectId']>;
  templateId?: Maybe<Scalars['ObjectId']>;
  overwriteCodeId?: Maybe<Scalars['ObjectId']>;
  shopId?: Maybe<Scalars['ObjectId']>;
};

/** Audit log, returns all mutations and interactions with the platform by any user or api. */
export type LogItemObjectType = {
  __typename?: 'LogItemObjectType';
  _id: Scalars['ObjectId'];
  type: Scalars['String'];
  operation: LogOperationEnum;
  severity: SeverityEnumType;
  description: Scalars['String'];
  raw: Scalars['String'];
  authType?: Maybe<AuthTypeEnum>;
  uid?: Maybe<Scalars['ObjectId']>;
  user?: Maybe<UserObjectType>;
  authenticatedApi?: Maybe<ApiKeyObjectType>;
  apiKeyId?: Maybe<Scalars['ObjectId']>;
  customerId?: Maybe<Scalars['ObjectId']>;
  reservationId?: Maybe<Scalars['ObjectId']>;
  serviceLocationId?: Maybe<Scalars['ObjectId']>;
  lockerId?: Maybe<Scalars['ObjectId']>;
  productId?: Maybe<Scalars['ObjectId']>;
  orderId?: Maybe<Scalars['ObjectId']>;
  shopId?: Maybe<Scalars['ObjectId']>;
  overwriteCodeId?: Maybe<Scalars['ObjectId']>;
  temperature?: Maybe<Scalars['Float']>;
  removeAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
};

/** The kind of operation executed to result in the given log */
export enum LogOperationEnum {
  Received = 'Received',
  Sent = 'Sent',
  Opened = 'Opened',
  Error = 'Error',
  Created = 'Created',
  Updated = 'Updated',
  Deleted = 'Deleted'
}

export type LogPaginatedResultObjectType = {
  __typename?: 'LogPaginatedResultObjectType';
  /** Documents */
  docs: Array<LogItemObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Sort the audit logs */
export type LogSortInputObjectType = {
  _id?: Maybe<SortEnumType>;
  type?: Maybe<SortEnumType>;
  operation?: Maybe<SortEnumType>;
  severity?: Maybe<SortEnumType>;
  temperature?: Maybe<SortEnumType>;
  authType?: Maybe<SortEnumType>;
};

/** The status of a website profile on Mollie. */
export type MollieConnectProfileObjectType = {
  __typename?: 'MollieConnectProfileObjectType';
  id: Scalars['String'];
  name: Scalars['String'];
  isVerified: Scalars['Boolean'];
};

/** The status of your connection with Mollie. */
export type MollieConnectStatusObjectType = {
  __typename?: 'MollieConnectStatusObjectType';
  _id: Scalars['ObjectId'];
  mollieOrganizationName?: Maybe<Scalars['String']>;
  canReceivePayments: Scalars['Boolean'];
  lastStatusCheckAt?: Maybe<Scalars['DateTime']>;
  profile?: Maybe<MollieConnectProfileObjectType>;
  testmode: Scalars['Boolean'];
  organisationId: Scalars['ObjectId'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** This is used to create a new API key, this can only be used by a real user in the platforms dashboard */
  createApiKey?: Maybe<ApiKeyObjectType>;
  /** This is used to create a new API key, this can only be used by a real user in the platforms dashboard */
  deleteApiKey?: Maybe<ApiKeyObjectType>;
  /** Used to create a new customer, which can be used to link to reservations and orders */
  createCustomer?: Maybe<CustomerObjectType>;
  /** Used to update an existing customer */
  updateCustomer?: Maybe<CustomerObjectType>;
  /** Used to delete a customer. */
  deleteCustomer?: Maybe<CustomerObjectType>;
  /** Used to import new customers, this also ensures no customers get duplicated */
  importCustomers: Array<Maybe<CustomerObjectType>>;
  /** Used to set the stable firmware version */
  setStableFirmwareVersion?: Maybe<Scalars['Boolean']>;
  /** Used to add a locker to the platform. */
  createLocker?: Maybe<LockerObjectType>;
  /** Used to update a lockers data. */
  updateLocker?: Maybe<LockerObjectType>;
  /** Opens a box in a locker, returns true if locker is active and box exists */
  openLockerBoxes?: Maybe<LockerObjectType>;
  /** Changes the lockers lockdown status */
  changeLockerLockdownStatus?: Maybe<LockerObjectType>;
  /** Used to delete a locker. */
  deleteLocker?: Maybe<LockerObjectType>;
  /** Update Mollie connect credentials. */
  connectMollie?: Maybe<MollieConnectStatusObjectType>;
  /** Disconnect Mollie organisation. */
  disconnectMollie?: Maybe<MollieConnectStatusObjectType>;
  /** Enable/Disable testmode for testing Mollie payments. */
  setMollieTestmode?: Maybe<MollieConnectStatusObjectType>;
  /** Change Mollie profile. */
  setSelectedMollieProfile?: Maybe<MollieConnectStatusObjectType>;
  /** Request an link to connect Mollie. */
  mollieConnectLink?: Maybe<Scalars['String']>;
  /** Used to delete certain notifications using the ids. */
  deleteNotifications?: Maybe<Scalars['Int']>;
  /** Used to remove all notifications. */
  clearNotifications?: Maybe<Scalars['Int']>;
  /** Used to update an orders contact details */
  updateOrderContactDetails?: Maybe<OrderObjectType>;
  /** Cancel an order */
  cancelOrder?: Maybe<OrderObjectType>;
  /** Used to cancel an order using an orderToken. */
  cancelOrderUsingToken?: Maybe<OrderObjectType>;
  /** Used to open the lockers of a specific order */
  openLockersByOrderIdAndToken?: Maybe<Scalars['Boolean']>;
  /** Used to create an organisation. */
  createOrganisation?: Maybe<OrganisationObjectType>;
  /** Used to update an organisation. */
  updateOrganisation?: Maybe<OrganisationObjectType>;
  /** Used to update organisation settings. */
  updateOrganisationSettings?: Maybe<OrganisationObjectType>;
  /** Used to update branding settings. */
  updateBrandingSettings?: Maybe<OrganisationObjectType>;
  /** Used to delete an organisation. */
  deleteOrganisation?: Maybe<OrganisationObjectType>;
  /** Used to update an existing overwrite code */
  updateOverwriteCode?: Maybe<OverwriteCodeObjectType>;
  /** Used to create a new overwrite code */
  createOverwriteCode?: Maybe<OverwriteCodeObjectType>;
  /** Used to delete an overwrite code. */
  deleteOverwriteCode?: Maybe<OverwriteCodeObjectType>;
  /** Used to create a new product */
  createProduct?: Maybe<ProductObjectType>;
  /** Used to update an existing product */
  updateProduct?: Maybe<ProductObjectType>;
  /** Used to import products */
  importProducts: Array<Maybe<ProductObjectType>>;
  /** Used to delete a product. */
  deleteProduct?: Maybe<ProductObjectType>;
  /** Used for creating a reservation */
  createReservation?: Maybe<ReservationObjectType>;
  /** Used for updating a reservation */
  updateReservation?: Maybe<ReservationObjectType>;
  /** Used for updating the status of a reservation */
  updateReservationStatus?: Maybe<Scalars['Boolean']>;
  /** Used to open the lockers of a specific reservation */
  openLockersByReservationIdAndToken?: Maybe<Scalars['Boolean']>;
  dispatchReservationNotification?: Maybe<ReservationObjectType>;
  /** Used to update a service location */
  updateServiceLocation?: Maybe<ServiceLocationObjectType>;
  /** Used to create a service location */
  createServiceLocation?: Maybe<ServiceLocationObjectType>;
  /** Used to delete a service location. */
  deleteServiceLocation?: Maybe<ServiceLocationObjectType>;
  /** Used to force a firmware update. */
  forceFirmwareUpdate?: Maybe<Scalars['Boolean']>;
  /** Used to update shop settings */
  updateShop?: Maybe<ShopObjectType>;
  /** Used to create a shop */
  createShop?: Maybe<ShopObjectType>;
  /** Used to delete a shop */
  deleteShop?: Maybe<ShopObjectType>;
  /** Used to create a subscription item */
  createUploadRequest: UploadRequestTokenObjectType;
  /** Mutation to add a user to the current organisation */
  addUserToOrganisation?: Maybe<UserObjectType>;
  /** Mutation used for updating a user's role within the current organisation. */
  updateUserRole?: Maybe<UserObjectType>;
  /** Mutation to remove a user from the current organisation */
  removeUserFromOrganisation?: Maybe<Scalars['Boolean']>;
  /** Mutation used to update your user preferences. */
  updateUserPreferences?: Maybe<UserObjectType>;
  /** Mutation used to update your password. */
  updatePassword?: Maybe<UserObjectType>;
  /** Mutation to confirm you have read the last announcements */
  hideAnnouncementForCurrentUser?: Maybe<Scalars['Boolean']>;
  /** Used to create a new product */
  updateQuotaLimit?: Maybe<QuotaUsageObjectType>;
  /** Used to create a reseller. */
  createReseller?: Maybe<ResellerObjectType>;
  /** Used to delete a reseller. */
  deleteReseller?: Maybe<ResellerObjectType>;
  /** Used to update a reseller. */
  updateReseller?: Maybe<ResellerObjectType>;
  /** Used to remove a user from a reseller. */
  removeUserFromReseller?: Maybe<Scalars['Boolean']>;
  /** Used to invite a user to a reseller. */
  inviteUserToReseller?: Maybe<UserObjectType>;
  /** Used to create a dealer. */
  createDealer?: Maybe<DealerObjectType>;
  /** Used to update a dealer. */
  updateDealer?: Maybe<DealerObjectType>;
  /** Used to delete a dealer. */
  deleteDealer?: Maybe<DealerObjectType>;
  /** Used to remove a user from a dealer. */
  removeUserFromDealer?: Maybe<Scalars['Boolean']>;
  /** Used to invite a user to a dealer. */
  inviteUserToDealer?: Maybe<UserObjectType>;
  /** Used to create an announcement */
  createAnnouncement?: Maybe<AnnouncementObjectType>;
  /** Used to update an announcement */
  updateAnnouncement?: Maybe<AnnouncementObjectType>;
  /** Used to delete an announcement */
  deleteAnnouncement?: Maybe<AnnouncementObjectType>;
  /** Used to create a new product */
  upsertReservationSettings?: Maybe<ReservationSettingsObjectType>;
  upsertWoytiPreferences?: Maybe<WoytiPreferences>;
  createWoytiOrder?: Maybe<OrderObjectType>;
  /** Upsert WooCommerce integration. */
  upsertWooCommerceIntegration?: Maybe<WooCommerceIntegrationObjectType>;
};


export type MutationCreateApiKeyArgs = {
  name: Scalars['String'];
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['ObjectId'];
};


export type MutationCreateCustomerArgs = {
  data: CreateCustomerInputObjectType;
};


export type MutationUpdateCustomerArgs = {
  id: Scalars['ObjectId'];
  data: UpdateCustomerInputObjectType;
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['ObjectId'];
};


export type MutationImportCustomersArgs = {
  customers: Array<CreateCustomerInputObjectType>;
};


export type MutationSetStableFirmwareVersionArgs = {
  firmwareId: Scalars['ObjectId'];
};


export type MutationCreateLockerArgs = {
  data: CreateLockerInputObjectType;
};


export type MutationUpdateLockerArgs = {
  id: Scalars['ObjectId'];
  data: UpdateLockerInputObjectType;
};


export type MutationOpenLockerBoxesArgs = {
  lockerId: Scalars['ObjectId'];
  boxIds: Array<Scalars['Int']>;
  openMainDoor?: Maybe<Scalars['Boolean']>;
};


export type MutationChangeLockerLockdownStatusArgs = {
  lockerId: Scalars['ObjectId'];
  newInLockdown?: Maybe<Scalars['Boolean']>;
};


export type MutationDeleteLockerArgs = {
  id: Scalars['ObjectId'];
};


export type MutationConnectMollieArgs = {
  code: Scalars['String'];
  state: Scalars['String'];
};


export type MutationSetMollieTestmodeArgs = {
  testmode: Scalars['Boolean'];
};


export type MutationSetSelectedMollieProfileArgs = {
  profileId: Scalars['String'];
};


export type MutationDeleteNotificationsArgs = {
  ids: Array<Scalars['ObjectId']>;
};


export type MutationUpdateOrderContactDetailsArgs = {
  id: Scalars['ObjectId'];
  data: UpdateOrderInputObjectType;
};


export type MutationCancelOrderArgs = {
  id: Scalars['ObjectId'];
};


export type MutationCancelOrderUsingTokenArgs = {
  id: Scalars['ObjectId'];
  token: Scalars['String'];
};


export type MutationOpenLockersByOrderIdAndTokenArgs = {
  id: Scalars['ObjectId'];
  token: Scalars['String'];
};


export type MutationCreateOrganisationArgs = {
  data: OrganisationInputObjectType;
};


export type MutationUpdateOrganisationArgs = {
  id: Scalars['ObjectId'];
  data: OrganisationInputObjectType;
};


export type MutationUpdateOrganisationSettingsArgs = {
  data: OrganisationSettingsInputObjectType;
};


export type MutationUpdateBrandingSettingsArgs = {
  data: BrandingSettingsInputObjectType;
};


export type MutationDeleteOrganisationArgs = {
  id: Scalars['ObjectId'];
};


export type MutationUpdateOverwriteCodeArgs = {
  id: Scalars['ObjectId'];
  data: OverwriteCodeInputObjectType;
};


export type MutationCreateOverwriteCodeArgs = {
  data: OverwriteCodeInputObjectType;
};


export type MutationDeleteOverwriteCodeArgs = {
  id: Scalars['ObjectId'];
};


export type MutationCreateProductArgs = {
  data: ProductInputObjectType;
};


export type MutationUpdateProductArgs = {
  id: Scalars['ObjectId'];
  data: ProductInputObjectType;
};


export type MutationImportProductsArgs = {
  products: Array<ProductInputObjectType>;
};


export type MutationDeleteProductArgs = {
  id: Scalars['ObjectId'];
};


export type MutationCreateReservationArgs = {
  data: CreateReservationInputObjectType;
};


export type MutationUpdateReservationArgs = {
  id: Scalars['ObjectId'];
  data: UpdateReservationInputObjectType;
};


export type MutationUpdateReservationStatusArgs = {
  id: Scalars['ObjectId'];
  data: UpdateReservationStatusInputObjectType;
};


export type MutationOpenLockersByReservationIdAndTokenArgs = {
  id: Scalars['ObjectId'];
  token: Scalars['String'];
};


export type MutationDispatchReservationNotificationArgs = {
  id: Scalars['ObjectId'];
};


export type MutationUpdateServiceLocationArgs = {
  id: Scalars['ObjectId'];
  data: ServiceLocationInputObjectType;
};


export type MutationCreateServiceLocationArgs = {
  data: ServiceLocationInputObjectType;
};


export type MutationDeleteServiceLocationArgs = {
  id: Scalars['ObjectId'];
};


export type MutationForceFirmwareUpdateArgs = {
  id: Scalars['ObjectId'];
};


export type MutationUpdateShopArgs = {
  id: Scalars['ObjectId'];
  data: ShopInputObjectType;
};


export type MutationCreateShopArgs = {
  data: ShopInputObjectType;
};


export type MutationDeleteShopArgs = {
  id: Scalars['ObjectId'];
};


export type MutationCreateUploadRequestArgs = {
  filename: Scalars['String'];
};


export type MutationAddUserToOrganisationArgs = {
  data: CreateUserInputObjectType;
};


export type MutationUpdateUserRoleArgs = {
  userId: Scalars['ObjectId'];
  role: Scalars['Int'];
};


export type MutationRemoveUserFromOrganisationArgs = {
  userId: Scalars['ObjectId'];
};


export type MutationUpdateUserPreferencesArgs = {
  data: UserPreferencesInputObjectType;
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String'];
};


export type MutationUpdateQuotaLimitArgs = {
  organisationId: Scalars['ObjectId'];
  type: QuotaTypeEnumType;
  newLimit?: Maybe<Scalars['Int']>;
};


export type MutationCreateResellerArgs = {
  data: ResellerInputObjectType;
};


export type MutationDeleteResellerArgs = {
  id: Scalars['ObjectId'];
};


export type MutationUpdateResellerArgs = {
  id: Scalars['ObjectId'];
  data: ResellerInputObjectType;
};


export type MutationRemoveUserFromResellerArgs = {
  resellerId: Scalars['ObjectId'];
  userId: Scalars['ObjectId'];
};


export type MutationInviteUserToResellerArgs = {
  resellerId: Scalars['ObjectId'];
  email: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreateDealerArgs = {
  data: DealerInputObjectType;
};


export type MutationUpdateDealerArgs = {
  id: Scalars['ObjectId'];
  data: DealerInputObjectType;
};


export type MutationDeleteDealerArgs = {
  id: Scalars['ObjectId'];
};


export type MutationRemoveUserFromDealerArgs = {
  dealerId: Scalars['ObjectId'];
  userId: Scalars['ObjectId'];
};


export type MutationInviteUserToDealerArgs = {
  dealerId: Scalars['ObjectId'];
  email: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreateAnnouncementArgs = {
  data: AnnouncementInputObjectType;
};


export type MutationUpdateAnnouncementArgs = {
  id: Scalars['ObjectId'];
  data: AnnouncementInputObjectType;
};


export type MutationDeleteAnnouncementArgs = {
  id: Scalars['ObjectId'];
};


export type MutationUpsertReservationSettingsArgs = {
  data: ReservationSettingsInputObjectType;
};


export type MutationUpsertWoytiPreferencesArgs = {
  data: WoytiPreferencesInput;
};


export type MutationCreateWoytiOrderArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  language: LanguageEnum;
  items: Array<Scalars['ObjectId']>;
  shopId: Scalars['ObjectId'];
};


export type MutationUpsertWooCommerceIntegrationArgs = {
  organisationId: Scalars['ObjectId'];
  shopId: Scalars['ObjectId'];
  apiUrl: Scalars['String'];
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
};

/** A notification. */
export type NotificationObjectType = {
  __typename?: 'NotificationObjectType';
  _id: Scalars['ObjectId'];
  message: Scalars['String'];
  severity: SeverityEnumType;
  link?: Maybe<Scalars['String']>;
  userId: Scalars['ObjectId'];
  createdAt: Scalars['DateTime'];
};

/** Which notification to send to a user and/or customer */
export enum NotificationTypeEnumType {
  /** Send sms notification */
  Sms = 'sms',
  /** Send email notification */
  Email = 'email'
}

/** Data needed to create a nutritional information table. */
export type NutritionalInformationInputObjectType = {
  /** Total amount of energy in kCal (multiplied by 100 for decimal points) */
  energy: Scalars['Int'];
  /** Total amount of fat in grams (multiplied by 100 for decimal points) */
  fat: Scalars['Int'];
  /** Total amount of saturated fat in grams (multiplied by 100 for decimal points) */
  saturatedFat: Scalars['Int'];
  /** Total amount of cholesterol in grams (multiplied by 100 for decimal points) */
  cholesterol: Scalars['Int'];
  /** Total amount of carbohydrate in grams (multiplied by 100 for decimal points) */
  carbohydrate: Scalars['Int'];
  /** Total amount of fiber in grams (multiplied by 100 for decimal points) */
  fiber: Scalars['Int'];
  /** Total amount of sugars in grams (multiplied by 100 for decimal points) */
  sugars: Scalars['Int'];
  /** Total amount of added sugars in grams (multiplied by 100 for decimal points) */
  addedSugars: Scalars['Int'];
  /** Total amount of protein in grams (multiplied by 100 for decimal points) */
  protein: Scalars['Int'];
  /** Total amount of salt in grams (multiplied by 100 for decimal points) */
  salt: Scalars['Int'];
};

/** Data needed to create a nutritional information table. */
export type NutritionalInformationObjectType = {
  __typename?: 'NutritionalInformationObjectType';
  /** Total amount of energy in kCal (multiplied by 100 for decimal points) */
  energy: Scalars['Int'];
  /** Total amount of fat in grams (multiplied by 100 for decimal points) */
  fat: Scalars['Int'];
  /** Total amount of saturated fat in grams (multiplied by 100 for decimal points) */
  saturatedFat: Scalars['Int'];
  /** Total amount of cholesterol in grams (multiplied by 100 for decimal points) */
  cholesterol: Scalars['Int'];
  /** Total amount of carbohydrate in grams (multiplied by 100 for decimal points) */
  carbohydrate: Scalars['Int'];
  /** Total amount of fiber in grams (multiplied by 100 for decimal points) */
  fiber: Scalars['Int'];
  /** Total amount of sugars in grams (multiplied by 100 for decimal points) */
  sugars: Scalars['Int'];
  /** Total amount of added sugars in grams (multiplied by 100 for decimal points) */
  addedSugars: Scalars['Int'];
  /** Total amount of protein in grams (multiplied by 100 for decimal points) */
  protein: Scalars['Int'];
  /** Total amount of salt in grams (multiplied by 100 for decimal points) */
  salt: Scalars['Int'];
};


/** Filters results to match these specified queries. */
export type OrderFilterInputObjectType = {
  /** Filters by order status(es) */
  status?: Maybe<Array<OrderStatusEnumType>>;
};

/** Object describing an order line. */
export type OrderLineObjectType = {
  __typename?: 'OrderLineObjectType';
  /** Description of the line, this is usually localized in the language of the customer. */
  description: Scalars['String'];
  /** Can this line be paid using Meal Vouchers */
  canUseMealVouchers: Scalars['Boolean'];
  /** The total price for the line in cent value */
  totalPrice: Scalars['Int'];
  /** VAT Rate percentage for example 600 for 6% */
  vatRate: Scalars['Int'];
  /** Discount percentage for example 500 for 5% */
  discountPercentage: Scalars['Int'];
  /** The id of the product that is linked to this line */
  productId?: Maybe<Scalars['ObjectId']>;
};

/** Object describing an order. */
export type OrderObjectType = {
  __typename?: 'OrderObjectType';
  /** Internal id used for linking with other data-types and to quickly find the product in the database. */
  _id: Scalars['ObjectId'];
  /** Numeric id used purely as a visual representation to the end-user */
  id: Scalars['Int'];
  /** Where did the order originate from (e-commerce, manual, ...) */
  origin: Scalars['String'];
  /** Current status of the order */
  status: OrderStatusEnumType;
  /** a list of all order lines */
  orderLines: Array<OrderLineObjectType>;
  /** The total value of the order in cent value */
  totalPrice: Scalars['Int'];
  /** The amount that has been refunded in cent value */
  refundedAmount: Scalars['Int'];
  /** Preferred language of the customer */
  language: LanguageEnum;
  /** First Name of the customer */
  firstName: Scalars['String'];
  /** Last Name of the customer */
  lastName: Scalars['String'];
  /** E-Mail of the customer */
  emails?: Maybe<Array<Scalars['String']>>;
  /** Customer this order is linked to. */
  customerId?: Maybe<Scalars['ObjectId']>;
  /** Customer this order is linked to. */
  customer?: Maybe<CustomerObjectType>;
  /** A list of reservation ids, only used for vending orders. */
  reservationIds: Array<Scalars['ObjectId']>;
  /** A list of reservation ids, only used for vending orders. */
  reservations: Array<ReservationObjectType>;
  /** A list of reservation ids, only used for vending orders. */
  pincode?: Maybe<Scalars['String']>;
  /** A link used to pay the order. */
  payLink?: Maybe<Scalars['String']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  /** A token used to be able to see the contents of the order. */
  orderToken: Scalars['String'];
  /** Amount of times a notification has been sent, ideally this should be 1. */
  notificationsSent: Scalars['Int'];
  shopId: Scalars['ObjectId'];
  shop: ShopObjectType;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type OrderPaginatedResultObjectType = {
  __typename?: 'OrderPaginatedResultObjectType';
  /** Documents */
  docs: Array<OrderObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Sort the results based on the value of this object */
export type OrderSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: Maybe<SortEnumType>;
  /** Sort based on the value: firstName */
  firstName?: Maybe<SortEnumType>;
  /** Sort based on the value: lastName */
  lastName?: Maybe<SortEnumType>;
  /** Sort based on the value: origin */
  origin?: Maybe<SortEnumType>;
  /** Sort based on the value: status */
  status?: Maybe<SortEnumType>;
};

/** The status of a given order */
export enum OrderStatusEnumType {
  /** Order has been created, not paid */
  Created = 'Created',
  /** Order has been paid */
  Paid = 'Paid',
  /** Order has expired */
  Expired = 'Expired',
  /** Pending order payment has been expired */
  PaymentExpired = 'PaymentExpired',
  /** Order has been canceled manually */
  Canceled = 'Canceled',
  /** Pending order payment has been canceled */
  PaymentCanceled = 'PaymentCanceled',
  /** Order has been refunded, this can only be done manually in the Mollie dashboard */
  Refunded = 'Refunded'
}

/** Information required to create or update an organisation. */
export type OrganisationInputObjectType = {
  dealerId: Scalars['ObjectId'];
  name: Scalars['String'];
  email: Scalars['String'];
  phonenumber: Scalars['PhoneNumber'];
  companyName: Scalars['String'];
  registrationNumber: Scalars['String'];
  vatNumber: Scalars['String'];
  address: AddressInputObjectType;
  language: LanguageEnum;
};

/** Information about an organisation. */
export type OrganisationObjectType = {
  __typename?: 'OrganisationObjectType';
  _id: Scalars['ObjectId'];
  /** External id used to identify viresmo organisations, this id gets put on invoices */
  id: Scalars['Int'];
  name: Scalars['String'];
  email: Scalars['String'];
  phonenumber: Scalars['PhoneNumber'];
  companyName: Scalars['String'];
  registrationNumber: Scalars['String'];
  vatNumber: Scalars['String'];
  address: AddressObjectType;
  language: LanguageEnum;
  brandColor: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  pathname: Scalars['String'];
  dealerId: Scalars['ObjectId'];
  dealer?: Maybe<DealerObjectType>;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type OrganisationPaginatedResultObjectType = {
  __typename?: 'OrganisationPaginatedResultObjectType';
  /** Documents */
  docs: Array<OrganisationObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Information required to create or update an organisation. */
export type OrganisationSettingsInputObjectType = {
  name: Scalars['String'];
  email: Scalars['String'];
  phonenumber: Scalars['PhoneNumber'];
  companyName: Scalars['String'];
  registrationNumber: Scalars['String'];
  vatNumber: Scalars['String'];
  address: AddressInputObjectType;
  language: LanguageEnum;
};

/** Object used for creating/updating an overwrite code */
export type OverwriteCodeInputObjectType = {
  /** internal shop id */
  shopId: Scalars['ObjectId'];
  /** Name for the overwrite code, usually the name of the employee */
  name: Scalars['String'];
  /** Pincode used to open the locker */
  pincode: Scalars['String'];
};

/** Overwrite code, these codes can open any lock in a locker */
export type OverwriteCodeObjectType = {
  __typename?: 'OverwriteCodeObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId'];
  /** Name for the overwrite code, usually the name of the employee */
  name: Scalars['String'];
  /** Pincode used to open the locker */
  pincode: Scalars['String'];
  /** Shop ID, points to the shop this service location belongs to */
  shopId: Scalars['ObjectId'];
  /** Shop */
  shop: ShopObjectType;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type OverwriteCodePaginatedResultObjectType = {
  __typename?: 'OverwriteCodePaginatedResultObjectType';
  /** Documents */
  docs: Array<OverwriteCodeObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

export type PaginatedAnnouncementObjectType = {
  __typename?: 'PaginatedAnnouncementObjectType';
  /** Documents */
  docs: Array<AnnouncementObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

export type PaginatedBillingLogResultObjectType = {
  __typename?: 'PaginatedBillingLogResultObjectType';
  /** Documents */
  docs: Array<BillingLogObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

export type PaginatedDealerResultObjectType = {
  __typename?: 'PaginatedDealerResultObjectType';
  /** Documents */
  docs: Array<DealerObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

export type PaginatedLockerTemperatureResultObjectType = {
  __typename?: 'PaginatedLockerTemperatureResultObjectType';
  /** Documents */
  docs: Array<LockerTemperatureObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

export type PaginatedNotificationsObjectType = {
  __typename?: 'PaginatedNotificationsObjectType';
  /** Documents */
  docs: Array<NotificationObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

export type PaginatedResellerResultObjectType = {
  __typename?: 'PaginatedResellerResultObjectType';
  /** Documents */
  docs: Array<ResellerObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

export type PaginatedUsageLedgerEntriesObjectType = {
  __typename?: 'PaginatedUsageLedgerEntriesObjectType';
  /** Documents */
  docs: Array<UsageLedgerEntryObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Define page size and offset, limited to 100 elements */
export type PaginationInputObjectType = {
  /** Amount of elements to skip */
  skip?: Scalars['Int'];
  /** Maximum amount of elements to return */
  limit?: Scalars['Int'];
};


/** Data about an item in a product collection */
export type ProductCollectionItemInputObjectType = {
  /** The ID of the product */
  productId: Scalars['ObjectId'];
  /** The amount of the product. */
  amount: Scalars['Int'];
};

/** Data about an item in a product collection */
export type ProductCollectionItemObjectType = {
  __typename?: 'ProductCollectionItemObjectType';
  /** The ID of the product */
  productId: Scalars['ObjectId'];
  /** The ID of the product */
  product?: Maybe<ProductObjectType>;
  /** The amount of the product. */
  amount: Scalars['Int'];
};

/** Data needed to create or edit a product. */
export type ProductInputObjectType = {
  /**
   * A google storage file key where the image is stored, for further processing
   * and linking (this has to be in the upload bucket of viresmo)
   */
  imageObjectKey?: Maybe<Scalars['String']>;
  /** A url to an image (max 25MB) */
  imageUrl?: Maybe<Scalars['String']>;
  /** PLU of the product */
  plu?: Maybe<Scalars['String']>;
  /** Name of the product */
  name: Array<LocalisedStringInputObjectType>;
  /** Description of the product */
  description: Array<LocalisedStringInputObjectType>;
  /** Allergens information for the product */
  allergens: Array<AllergensEnumType>;
  /** True if a product has nutritional information */
  hasNutritionalInformation?: Scalars['Boolean'];
  /** Nutritional information for the product */
  nutritionalInformation: NutritionalInformationInputObjectType;
  /** Unit to represent the volume of product */
  unitType: UnitEnumType;
  /** Minimum amount a customer has to buy */
  minimumAmount: Scalars['Int'];
  /** The interval with which the amount will be incremented or decremented */
  interval: Scalars['Int'];
  /** The price per interval (multiplied by 100 to be able to represent decimal points) */
  price: Scalars['Int'];
  /** VAT Rate for the product, multiplied by 100, example 6% = 600 */
  vatRate: Scalars['Int'];
  /** Can this product be paid using dinner cheques? */
  canUseMealVouchers: Scalars['Boolean'];
  /** A list of products that are included in this product */
  includedProducts?: Maybe<Array<ProductCollectionItemInputObjectType>>;
};

/** Object describing a product. */
export type ProductObjectType = {
  __typename?: 'ProductObjectType';
  /** Internal id used for linking with other data-types and to quickly find the product in the database. */
  _id: Scalars['ObjectId'];
  /** Numeric id used purely as a visual representation to the end-user */
  id: Scalars['Int'];
  /** PLU of the product */
  plu?: Maybe<Scalars['String']>;
  /** Image of the product */
  imageUrl?: Maybe<Scalars['String']>;
  /** Name of the product */
  name: Array<LocalisedStringObjectType>;
  /** Description of the product */
  description: Array<LocalisedStringObjectType>;
  /** Allergens information for the product */
  allergens: Array<AllergensEnumType>;
  /** True if a product has nutritional information */
  hasNutritionalInformation: Scalars['Boolean'];
  /** Nutritional information for the product */
  nutritionalInformation: NutritionalInformationObjectType;
  /** Unit to represent the volume of product */
  unitType: UnitEnumType;
  /** Minimum amount a customer has to buy */
  minimumAmount: Scalars['Int'];
  /** The interval with which the amount will be incremented or decremented */
  interval: Scalars['Int'];
  /** The price per interval */
  price: Scalars['Int'];
  /** VAT Rate for the product, multiplied by 100, example 6% = 600 */
  vatRate: Scalars['Int'];
  /** Can this product be paid using dinner cheques? */
  canUseMealVouchers: Scalars['Boolean'];
  /** A list of products that are included in this product */
  includedProducts: Array<ProductCollectionItemObjectType>;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type ProductPaginatedResultObjectType = {
  __typename?: 'ProductPaginatedResultObjectType';
  /** Documents */
  docs: Array<ProductObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Sort the results based on the value of this object */
export type ProductSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: Maybe<SortEnumType>;
};

export type Query = {
  __typename?: 'Query';
  searchAddress: Array<AddressObjectType>;
  /** List all api keys */
  apiKeys?: Maybe<ApiKeyPaginatedResultObjectType>;
  /** Get an api key by id */
  getApiKeyById?: Maybe<ApiKeyObjectType>;
  /** List all logs */
  logs?: Maybe<LogPaginatedResultObjectType>;
  /** Get a single log item by the unique id */
  getLogItemById?: Maybe<LogItemObjectType>;
  /** Return all customers, can be paginated and sorted using the arguments */
  customers?: Maybe<CustomerPaginatedResultObjectType>;
  /** Search for customers using a query. This matches customers by name, email and phonenumber. */
  findCustomers: Array<CustomerObjectType>;
  /** Get a customer by the internal id, used within the viresmo platform. */
  getCustomerById?: Maybe<CustomerObjectType>;
  /** List all device logs. */
  deviceLogs?: Maybe<DeviceLogPaginatedResultObjectType>;
  /** Get a single device log by it's unique id */
  getDeviceLogById?: Maybe<DeviceLogObjectType>;
  /** Return all firmware versions, can be paginated and sorted using the arguments */
  firmwareVersions?: Maybe<FirmwareVersionPaginatedResultObjectType>;
  /** Used to get the latest stable firmware version */
  getStableFirmwareVersion?: Maybe<FirmwareVersionObjectType>;
  /** Returns a list of all lockers, can be paginated using the arguments */
  lockers?: Maybe<LockerPaginatedResultObjectType>;
  /** Finds lockers using a query */
  findLockers: Array<LockerObjectType>;
  /** Get a locker by using our internal id */
  getLockerById?: Maybe<LockerObjectType>;
  /** Request the Mollie connection status. */
  mollieConnectStatus?: Maybe<MollieConnectStatusObjectType>;
  /** Request an link to connect Mollie. */
  listMollieProfiles: Array<MollieConnectProfileObjectType>;
  /** Lists all notifications, you can specify the arguments to define sorting and pagination */
  notifications?: Maybe<PaginatedNotificationsObjectType>;
  /** Return all orders, can be paginated and sorted using the arguments */
  orders?: Maybe<OrderPaginatedResultObjectType>;
  /** Get an order by the internal id, used within the viresmo platform. */
  getOrderById?: Maybe<OrderObjectType>;
  /** Get an order by the internal id, used within the viresmo platform. */
  getOrderByTokenAndId?: Maybe<OrderObjectType>;
  /** Search for orders using a query. This matches orders by name and id. */
  findOrders: Array<OrderObjectType>;
  /** Get the organisation the user is currently logged in to. */
  getCurrentOrganisation?: Maybe<OrganisationObjectType>;
  /** Get the organisation that matches the provided organisationId. */
  getOrganisationById?: Maybe<OrganisationObjectType>;
  /** List organisations. */
  organisations?: Maybe<OrganisationPaginatedResultObjectType>;
  /** Search for organisations using a query. This matches organisations by name, invoice email, id and company name. */
  findOrganisations: Array<OrganisationObjectType>;
  /** List overwrite codes based on arguments provided */
  overwriteCodes?: Maybe<OverwriteCodePaginatedResultObjectType>;
  /** Get a single overwrite code based on an internal id */
  getOverwriteCodeById?: Maybe<OverwriteCodeObjectType>;
  /** Search for overwrite codes using a query. */
  findOverwriteCodes: Array<OverwriteCodeObjectType>;
  /** Return all products, can be paginated and sorted using the arguments */
  products?: Maybe<ProductPaginatedResultObjectType>;
  /** Get a product by the internal id, used within the viresmo platform. */
  getProductById?: Maybe<ProductObjectType>;
  /** Search for products using a query. This matches products by name and id. */
  findProducts: Array<ProductObjectType>;
  /** Used for listing all reservations matching the arguments provided */
  reservations?: Maybe<ReservationPaginatedResultObjectType>;
  /** Used to get the reservation that matches the internal id provided */
  getReservationById?: Maybe<ReservationObjectType>;
  /** Used to get the reservation that matches the internal id and token provided */
  getReservationByIdAndToken?: Maybe<ReservationObjectType>;
  /** Search for reservations using a query. */
  findReservations: Array<ReservationObjectType>;
  /** List service locations based on arguments provided */
  serviceLocations?: Maybe<ServiceLocationPaginatedResultObjectType>;
  /** Get a single service location based on an internal id */
  getServiceLocationById?: Maybe<ServiceLocationObjectType>;
  /** Search for service locations using a query. */
  findServiceLocations: Array<ServiceLocationObjectType>;
  /** List all service locations based on arguments provided */
  allServiceLocations?: Maybe<ServiceLocationPaginatedResultObjectType>;
  /** List shops based on arguments provided */
  shops: ShopPaginatedResultObjectType;
  /** Get a single shop based on an internal id */
  getShopById?: Maybe<ShopObjectType>;
  /** Search for shop using a query. */
  findShops: Array<ShopObjectType>;
  organisationUsers?: Maybe<UserPaginatedResultObjectType>;
  getCurrentUser?: Maybe<UserObjectType>;
  getUserById?: Maybe<UserObjectType>;
  /** Get the current quota usages */
  quotaUsages: Array<Maybe<QuotaUsageObjectType>>;
  /** Paginate the usage ledger entries */
  usageLedgerEntries: PaginatedUsageLedgerEntriesObjectType;
  /** List resellers. */
  resellers?: Maybe<PaginatedResellerResultObjectType>;
  /** Get the reseller by id. */
  reseller?: Maybe<ResellerObjectType>;
  /** Get the users of a reseller by id. */
  resellerUsers?: Maybe<UserPaginatedResultObjectType>;
  /** List dealers. */
  dealers?: Maybe<PaginatedDealerResultObjectType>;
  /** Get the dealer by id. */
  dealer?: Maybe<DealerObjectType>;
  /** Get the users of a dealer by id. */
  dealerUsers?: Maybe<UserPaginatedResultObjectType>;
  /** Returns a list of all locker temperatures, can be paginated using the arguments */
  lockerTemperatures?: Maybe<PaginatedLockerTemperatureResultObjectType>;
  /** List all announcements */
  announcements?: Maybe<PaginatedAnnouncementObjectType>;
  /** Get an announcement by id */
  getAnnouncementById?: Maybe<AnnouncementObjectType>;
  /** Get the current quota usages */
  reservationSettings?: Maybe<ReservationSettingsObjectType>;
  /** List billing logs. */
  billingLogs?: Maybe<PaginatedBillingLogResultObjectType>;
  /** Get a billing log by id. */
  findOneBillingLogById?: Maybe<BillingLogObjectType>;
  /** @deprecated Use getOrganisationByWoytiPathname instead */
  getOrganisationByWoytiPathname?: Maybe<WoytiOrganisationObjectType>;
  getOrganisationWoytiShops: WoytiShopPaginatedResultObjectType;
  getWoytiShops: WoytiShopPaginatedResultObjectType;
  getWoytiShopById?: Maybe<WoytiShopObjectType>;
  getWoytiShoppingCart: Array<WoytiReservationObjectType>;
  getWoytiReservationsByShopId: Array<WoytiReservationObjectType>;
  /** Fetch the woocommerce integration config. */
  woocommerceIntegration?: Maybe<WooCommerceIntegrationObjectType>;
};


export type QuerySearchAddressArgs = {
  query: Scalars['String'];
  countries?: Maybe<Array<CountryEnum>>;
};


export type QueryApiKeysArgs = {
  pagination: PaginationInputObjectType;
};


export type QueryGetApiKeyByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryLogsArgs = {
  sort?: Maybe<LogSortInputObjectType>;
  filter?: Maybe<LogFilterInputObjectType>;
  pagination?: PaginationInputObjectType;
};


export type QueryGetLogItemByIdArgs = {
  id?: Maybe<Scalars['ObjectId']>;
};


export type QueryCustomersArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  sort?: Maybe<CustomerSortInputObjectType>;
  pagination?: PaginationInputObjectType;
};


export type QueryFindCustomersArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  query?: Maybe<Scalars['String']>;
  returnOnEmptyQuery?: Maybe<Scalars['Boolean']>;
};


export type QueryGetCustomerByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryDeviceLogsArgs = {
  sort?: Maybe<DeviceLogSortInputObjectType>;
  filter?: Maybe<DeviceLogFilterInputObjectType>;
  pagination?: PaginationInputObjectType;
};


export type QueryGetDeviceLogByIdArgs = {
  id?: Maybe<Scalars['ObjectId']>;
};


export type QueryFirmwareVersionsArgs = {
  firmwareType: FirmwareTypeEnum;
  sort?: Maybe<FirmwareVersionSortInputObjectType>;
  pagination?: PaginationInputObjectType;
};


export type QueryGetStableFirmwareVersionArgs = {
  firmwareType: FirmwareTypeEnum;
};


export type QueryLockersArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  pagination?: PaginationInputObjectType;
};


export type QueryFindLockersArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  query?: Maybe<Scalars['String']>;
  returnOnEmptyQuery?: Maybe<Scalars['Boolean']>;
};


export type QueryGetLockerByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryNotificationsArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryOrdersArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  sort?: Maybe<OrderSortInputObjectType>;
  filter?: Maybe<OrderFilterInputObjectType>;
  pagination?: PaginationInputObjectType;
};


export type QueryGetOrderByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryGetOrderByTokenAndIdArgs = {
  id: Scalars['ObjectId'];
  token: Scalars['String'];
};


export type QueryFindOrdersArgs = {
  shopId: Scalars['ObjectId'];
  query?: Maybe<Scalars['String']>;
  returnOnEmptyQuery?: Maybe<Scalars['Boolean']>;
};


export type QueryGetOrganisationByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryOrganisationsArgs = {
  pagination?: PaginationInputObjectType;
  dealerId?: Maybe<Scalars['ObjectId']>;
};


export type QueryFindOrganisationsArgs = {
  query?: Maybe<Scalars['String']>;
  returnOnEmptyQuery?: Maybe<Scalars['Boolean']>;
};


export type QueryOverwriteCodesArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  pagination?: PaginationInputObjectType;
};


export type QueryGetOverwriteCodeByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryFindOverwriteCodesArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  query?: Maybe<Scalars['String']>;
  returnOnEmptyQuery?: Maybe<Scalars['Boolean']>;
};


export type QueryProductsArgs = {
  sort?: Maybe<ProductSortInputObjectType>;
  pagination?: PaginationInputObjectType;
};


export type QueryGetProductByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryFindProductsArgs = {
  query?: Maybe<Scalars['String']>;
  returnOnEmptyQuery?: Maybe<Scalars['Boolean']>;
};


export type QueryReservationsArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  sort?: Maybe<ReservationSortInputObjectType>;
  pagination?: PaginationInputObjectType;
  filter?: Maybe<ReservationFilterInputObjectType>;
};


export type QueryGetReservationByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryGetReservationByIdAndTokenArgs = {
  id: Scalars['ObjectId'];
  token: Scalars['String'];
};


export type QueryFindReservationsArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  query?: Maybe<Scalars['String']>;
  filter?: Maybe<ReservationFilterInputObjectType>;
  returnOnEmptyQuery?: Maybe<Scalars['Boolean']>;
};


export type QueryServiceLocationsArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  pagination?: PaginationInputObjectType;
};


export type QueryGetServiceLocationByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryFindServiceLocationsArgs = {
  shopId?: Maybe<Scalars['ObjectId']>;
  query?: Maybe<Scalars['String']>;
  returnOnEmptyQuery?: Maybe<Scalars['Boolean']>;
};


export type QueryAllServiceLocationsArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryShopsArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryGetShopByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryFindShopsArgs = {
  query?: Maybe<Scalars['String']>;
  returnOnEmptyQuery?: Maybe<Scalars['Boolean']>;
};


export type QueryOrganisationUsersArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryGetUserByIdArgs = {
  id?: Maybe<Scalars['ObjectId']>;
};


export type QueryQuotaUsagesArgs = {
  organisationId: Scalars['ObjectId'];
  types: Array<QuotaTypeEnumType>;
};


export type QueryUsageLedgerEntriesArgs = {
  organisationId: Scalars['ObjectId'];
  type: QuotaTypeEnumType;
  pagination?: PaginationInputObjectType;
};


export type QueryResellersArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryResellerArgs = {
  id: Scalars['ObjectId'];
};


export type QueryResellerUsersArgs = {
  resellerId: Scalars['ObjectId'];
  pagination?: PaginationInputObjectType;
};


export type QueryDealersArgs = {
  pagination?: PaginationInputObjectType;
  filter?: DealerFilterInputObjectType;
};


export type QueryDealerArgs = {
  id: Scalars['ObjectId'];
};


export type QueryDealerUsersArgs = {
  dealerId: Scalars['ObjectId'];
  pagination?: PaginationInputObjectType;
};


export type QueryLockerTemperaturesArgs = {
  lockerId: Scalars['ObjectId'];
  pagination?: PaginationInputObjectType;
};


export type QueryAnnouncementsArgs = {
  pagination: PaginationInputObjectType;
};


export type QueryGetAnnouncementByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryReservationSettingsArgs = {
  shopId: Scalars['ObjectId'];
  organisationId: Scalars['ObjectId'];
};


export type QueryBillingLogsArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryFindOneBillingLogByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryGetOrganisationByWoytiPathnameArgs = {
  pathname?: Maybe<Scalars['String']>;
};


export type QueryGetOrganisationWoytiShopsArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryGetWoytiShopsArgs = {
  pagination?: PaginationInputObjectType;
  testmode?: Maybe<Scalars['Boolean']>;
};


export type QueryGetWoytiShopByIdArgs = {
  id: Scalars['ObjectId'];
};


export type QueryGetWoytiShoppingCartArgs = {
  items: Array<Scalars['ObjectId']>;
  shopId: Scalars['ObjectId'];
};


export type QueryGetWoytiReservationsByShopIdArgs = {
  shopId: Scalars['ObjectId'];
  shouldReturnSoldReservations?: Maybe<Scalars['Boolean']>;
};


export type QueryWoocommerceIntegrationArgs = {
  organisationId: Scalars['ObjectId'];
  shopId: Scalars['ObjectId'];
};

/** A list of all possible Quota types */
export enum QuotaTypeEnumType {
  /** Quota is of type SMS */
  Sms = 'SMS',
  /** Quota is of type Reservations */
  Reservations = 'Reservations',
  /** Quota is of type Customers */
  Customers = 'Customers',
  /** Quota is of type Emails */
  Emails = 'Emails',
  /** Quota is of type Users */
  Users = 'Users',
  /** Quota is of type Products */
  Products = 'Products',
  /** Quota is of type Uploads */
  Uploads = 'Uploads'
}

/** Object that describes the current quota usage and limit */
export type QuotaUsageObjectType = {
  __typename?: 'QuotaUsageObjectType';
  _id: Scalars['ObjectId'];
  type: QuotaTypeEnumType;
  /** Used amount in the current quotas timespan */
  usage: Scalars['Float'];
  /** Total limit of the quota (baseLimit * multiplier) */
  limit: Scalars['Float'];
  /** Base limit, this gets multiplied by the multiplier to get the actual limit */
  limitBase: Scalars['Float'];
  /** The multiplier that is used to calculate the total limit */
  multiplier: Scalars['Float'];
  /** The type of multiplier that is used to calculate the total limit */
  multiplierType?: Maybe<Scalars['String']>;
  /** Datetime of last reset */
  lastResetAt?: Maybe<Scalars['DateTime']>;
  /** Datetime of next reset */
  resetsAt?: Maybe<Scalars['DateTime']>;
  /** id of the linked organisation */
  organisationId: Scalars['ObjectId'];
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

/** Information required to create or update a reseller. */
export type ResellerInputObjectType = {
  companyName: Scalars['String'];
  registrationNumber: Scalars['String'];
  vatNumber: Scalars['String'];
  email: Scalars['String'];
  phonenumber: Scalars['PhoneNumber'];
  address: AddressInputObjectType;
};

/** Information about a reseller. */
export type ResellerObjectType = {
  __typename?: 'ResellerObjectType';
  _id: Scalars['ObjectId'];
  /** External id used to identify a reseller, this id might get used for invoices and support */
  id: Scalars['Int'];
  companyName: Scalars['String'];
  registrationNumber: Scalars['String'];
  vatNumber: Scalars['String'];
  email: Scalars['String'];
  phonenumber: Scalars['PhoneNumber'];
  address: AddressObjectType;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

/** Filters results to match these specified queries. */
export type ReservationFilterInputObjectType = {
  /** Filters reservations to be within this date range */
  pickupDateTime?: Maybe<DateRangeInputObjectType>;
  /** Filters reservations based on whether they are for vending purposes */
  isVendingReservation?: Maybe<Scalars['Boolean']>;
  /** Filters by reservation status(es) */
  status?: Maybe<Array<ReservationStatusEnumType>>;
};

/** Object that contains all information about a reservation */
export type ReservationObjectType = {
  __typename?: 'ReservationObjectType';
  /** An internal id used within the platform */
  _id: Scalars['ObjectId'];
  /** A sequential numeric id, mainly used for visual purposes */
  id: Scalars['Int'];
  /** Current status of the reservation */
  status: ReservationStatusEnumType;
  /** The time the reservation is planned for pickup */
  pickupDateTime: Scalars['DateTime'];
  /** An optional external id to identify the order, mainly used for integrating with 3rd party platforms */
  externalOrderId?: Maybe<Scalars['String']>;
  /** An optional id pointing to a linked order */
  orderId?: Maybe<Scalars['ObjectId']>;
  /** The order orderId points to */
  order?: Maybe<OrderObjectType>;
  /** A 4-5 character numeric pincode used for opening the locker at pickup */
  pincode: Scalars['String'];
  /** True if this pincode has not been generated but defined by a user */
  isCustomPincode: Scalars['Boolean'];
  /** If true and the reservation has reach the configured time before pickup, we will automatically send a notification. */
  automaticallySendNotification: Scalars['Boolean'];
  /** If true and the reservation has been picked up this locker will remain reserved untill manually completed. */
  noAutoComplete: Scalars['Boolean'];
  /** The notifications that should be dispatched x amount of time before pickup. */
  notificationTypes: Array<Maybe<NotificationTypeEnumType>>;
  /** Information about the reservation, this is usually a description of the content. */
  extraInformation?: Maybe<Scalars['String']>;
  /** The boxes this reservation occupies. */
  boxes: Array<BoxReservationObjectType>;
  /** The internal id of the customer this reservation belongs to. */
  customerId?: Maybe<Scalars['ObjectId']>;
  /** The customer this reservation belongs to. */
  customer?: Maybe<CustomerObjectType>;
  /** The first name of the customer. */
  firstName: Scalars['String'];
  /** The last name of the customer. */
  lastName: Scalars['String'];
  /** The email of the customer. */
  emails: Array<Scalars['String']>;
  /** The mobile phone number of the customer. */
  phonenumbers: Array<Scalars['PhoneNumber']>;
  language: LanguageEnum;
  /** A list of vending product items */
  vendingProducts: Array<ProductCollectionItemObjectType>;
  /** A discount percentage to apply to the vending total price, ex 500 => 5% */
  vendingDiscount?: Maybe<Scalars['Int']>;
  /** The total price of the reservation for vending purposes */
  vendingTotalPrice?: Maybe<Scalars['Int']>;
  /** Is reservation a vending reservation */
  isVendingReservation: Scalars['Boolean'];
  /** Amount of times a notification has been sent, ideally this should be 1. */
  notificationsSent: Scalars['Int'];
  /** Should customer still pay this reservation, this will send a pay link to the customer when box gets reserved. */
  shouldCustomerPay?: Maybe<Scalars['Boolean']>;
  /** Does this reservation contain food. */
  canUseMealVouchers?: Maybe<Scalars['Boolean']>;
  shopId: Scalars['ObjectId'];
  shop?: Maybe<ShopObjectType>;
  sendNotificationAt?: Maybe<Scalars['DateTime']>;
  /** Last time the status has been updated */
  updatedStatusAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type ReservationPaginatedResultObjectType = {
  __typename?: 'ReservationPaginatedResultObjectType';
  /** Documents */
  docs: Array<ReservationObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Object that describes the reservation settings input */
export type ReservationSettingsInputObjectType = {
  /** If this is true, a box will be selected by default */
  selectDefaultBox: Scalars['Boolean'];
  /** If this is true a customer should pay by default */
  shouldCustomerPay: Scalars['Boolean'];
  shopId: Scalars['ObjectId'];
  organisationId: Scalars['ObjectId'];
};

/** Object that describes the current quota usage and limit */
export type ReservationSettingsObjectType = {
  __typename?: 'ReservationSettingsObjectType';
  _id: Scalars['String'];
  /** If this is true, a box will be selected by default */
  selectDefaultBox: Scalars['Boolean'];
  /** If this is true a customer should pay by default */
  shouldCustomerPay: Scalars['Float'];
  shopId: Scalars['ObjectId'];
  organisationId: Scalars['ObjectId'];
  updatedAt: Scalars['DateTime'];
};

/** Sort the results based on the value of this object */
export type ReservationSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: Maybe<SortEnumType>;
  /** Sort based on the value: id */
  id?: Maybe<SortEnumType>;
  /** Sort based on the value: status */
  status?: Maybe<SortEnumType>;
  /** Sort based on the value: pickupDateTime */
  pickupDateTime?: Maybe<SortEnumType>;
  /** Sort based on the value: orderId */
  orderId?: Maybe<SortEnumType>;
  /** Sort based on the value: externalOrderId */
  externalOrderId?: Maybe<SortEnumType>;
  /** Sort based on the value: pincode */
  pincode?: Maybe<SortEnumType>;
  /** Sort based on the value: noAutoComplete */
  noAutoComplete?: Maybe<SortEnumType>;
  /** Sort based on the value: notificationTypes */
  notificationTypes?: Maybe<SortEnumType>;
  /** Sort based on the value: customerId */
  customerId?: Maybe<SortEnumType>;
};

/** The current status of the reservation */
export enum ReservationStatusEnumType {
  /** Reservation has been cancelled */
  Cancelled = 'cancelled',
  /** Reservation has been created */
  Created = 'created',
  /** A box in the locker has been reserved */
  Reserved = 'reserved',
  /**
   * Reservation has been ordered in the vending machine, not neccessarily paid. If
   * order gets cancelled or expires it will return to reserved.
   */
  Ordered = 'ordered',
  /** Reservation ready notifications have been sent */
  Sent = 'sent',
  /** Reservation has been picked up */
  Completed = 'completed'
}

/** The state of the gateway linked to the service location */
export type ServiceLocationDeviceStateObjectType = {
  __typename?: 'ServiceLocationDeviceStateObjectType';
  /** Firmware versions of the gateway */
  firmwareVersions: DeviceFirmwareVersionsObjectType;
  /** Config version of the gateway */
  configVersion: Scalars['Int'];
  /** Connection status online/offline */
  connectionStatus: ConnectionStatusEnum;
  /** Last time we received a heartbeat */
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  /** Last time we received a state update */
  lastStateUpdate?: Maybe<Scalars['DateTime']>;
  /** Last time we received an MQTT error */
  lastErrorAt?: Maybe<Scalars['DateTime']>;
  /** Last time the device was offline */
  lastOfflineAt?: Maybe<Scalars['DateTime']>;
  /** Last error message we received */
  lastErrorMessage?: Maybe<Scalars['String']>;
};

/** Object used for creating/updating a new service location */
export type ServiceLocationInputObjectType = {
  /** Shop ID, points to the shop this service location belongs to */
  shopId: Scalars['ObjectId'];
  /** Should this device receive the newest Beta firmware? If this is false, it defaults to the stable release channel. */
  isBetaTester: Scalars['Boolean'];
  /** Device id of the gateway */
  deviceId: Scalars['String'];
  /** Serial number of the router */
  routerSerial: Scalars['String'];
  /** iccid of the sim card */
  iccid: Scalars['String'];
  /** Start date of the billing cycle, devices are not allowed to use any data before this date */
  billingStartDate?: Maybe<Scalars['DateTime']>;
};

/** Service location is just a gateway but we messed up naming at the start */
export type ServiceLocationObjectType = {
  __typename?: 'ServiceLocationObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId'];
  /** Device id of the gateway */
  deviceId: Scalars['String'];
  /** A flag to indicate that this is a test-device used for testing new firmware */
  isBetaTester: Scalars['Boolean'];
  /** State of the device/gateway */
  deviceState: ServiceLocationDeviceStateObjectType;
  /** Amount of MQTT messages that are queued for this gateway */
  queuedMessagesCount: Scalars['Int'];
  /** All lockers that are part of this service location */
  lockers: Array<LockerObjectType>;
  /** Shop ID, points to the shop this service location belongs to */
  shopId: Scalars['ObjectId'];
  /** Shop */
  shop?: Maybe<ShopObjectType>;
  /** Organisation ID, points to the organisation this service location belongs to */
  organisationId: Scalars['ObjectId'];
  organisation?: Maybe<OrganisationObjectType>;
  routerSerial: Scalars['String'];
  teltonikaDevice?: Maybe<TeltonikaDeviceObjectType>;
  iccid: Scalars['String'];
  simCard?: Maybe<SimCardDeviceObjectType>;
  /** Start date of the billing cycle, devices are not allowed to use any data before this date */
  billingStartDate?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type ServiceLocationPaginatedResultObjectType = {
  __typename?: 'ServiceLocationPaginatedResultObjectType';
  /** Documents */
  docs: Array<ServiceLocationObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Severity/importance of a notification */
export enum SeverityEnumType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger'
}

/** Object used for creating/updating a shop */
export type ShopInputObjectType = {
  /** Name of the service location */
  name: Scalars['String'];
  /** Phone number that gets used for supporting your customers */
  phonenumber: Scalars['PhoneNumber'];
  /** Email that gets used for supporting your customers */
  email: Scalars['String'];
  /** The location of the service location by address */
  address: AddressInputObjectType;
  /** Amount of minutes before the pickup date/time that the notification should be sent */
  timeBeforeConfirmationDispatch: Scalars['Int'];
  /** Extra note that gets appended to each mail */
  emailNote?: Maybe<Scalars['String']>;
  /** The amount of hours a customer has to pickup an order when ordering from the vending machine */
  vendingPickupTime?: Maybe<Scalars['Int']>;
  /** If this is true, the shop will not be shown in the overview page of the virtual vending machine */
  hideVirtualVendingInOverview?: Maybe<Scalars['Boolean']>;
  /** url to the webshop of this shop */
  webshopUrl?: Maybe<Scalars['String']>;
};

/** Shop */
export type ShopObjectType = {
  __typename?: 'ShopObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId'];
  /** Name of the service location */
  name: Scalars['String'];
  /** Phone number that gets used for supporting your customers */
  phonenumber: Scalars['PhoneNumber'];
  /** Email that gets used for supporting your customers */
  email: Scalars['String'];
  /** The location of the service location by address */
  address: AddressObjectType;
  /** Amount of minutes before the pickup date/time that the notification should be sent */
  timeBeforeConfirmationDispatch: Scalars['Int'];
  /** The amount of hours a customer has to pickup an order when ordering from the vending machine */
  vendingPickupTime: Scalars['Int'];
  /** If this is true, the shop will not be shown in the virtual vending overview page */
  hideVirtualVendingInOverview: Scalars['Boolean'];
  /**
   * Amount of vending reservations currently available for this shop
   * @deprecated use WoytiShopObjectType instead
   */
  vendingReservationsCount: Scalars['Int'];
  /** Extra note that gets appended to each email to a customer */
  emailNote?: Maybe<Scalars['String']>;
  /** url to the webshop of this shop */
  webshopUrl: Scalars['String'];
  /** Internal id used for linking to the organisation */
  organisationId: Scalars['ObjectId'];
  /** Organisation this shop belongs to */
  organisation: OrganisationObjectType;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type ShopPaginatedResultObjectType = {
  __typename?: 'ShopPaginatedResultObjectType';
  /** Documents */
  docs: Array<ShopObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

/** Sim card data */
export type SimCardDeviceObjectType = {
  __typename?: 'SimCardDeviceObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId'];
  iccid: Scalars['String'];
  imsi: Scalars['String'];
  imei: Scalars['String'];
  label: Scalars['String'];
  subscription_state: Scalars['String'];
  subscription_description: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

/** Sort direction */
export enum SortEnumType {
  Asc = 'asc',
  Desc = 'desc'
}

/** Teltonika device */
export type TeltonikaDeviceObjectType = {
  __typename?: 'TeltonikaDeviceObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId'];
  /** teltonika internal id */
  id: Scalars['Int'];
  /** teltonika model */
  model: Scalars['String'];
  /** teltonika device name */
  name: Scalars['String'];
  /** teltonika device description */
  description: Scalars['String'];
  /** teltonika device serial */
  serial: Scalars['String'];
  /** teltonika device mac */
  mac: Scalars['String'];
  /** teltonika device wlan_mac */
  wlan_mac: Scalars['String'];
  /** teltonika device firmware version */
  firmware: Scalars['String'];
  /** teltonika device sim_state */
  sim_state: Scalars['String'];
  /** teltonika device connection_type */
  connection_type: Scalars['String'];
  /** Connection status online/offline */
  connection_status: ConnectionStatusEnum;
  /** teltonika device connection_uptime in seconds */
  last_connection_uptime: Scalars['Int'];
  /** teltonika device imsi */
  imsi: Scalars['String'];
  /** teltonika device imei */
  imei: Scalars['String'];
  /** teltonika device iccid */
  iccid: Scalars['String'];
  /** teltonika device monitoring_enabled */
  is_monitoring_enabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

/** A list of all possible unit types */
export enum UnitEnumType {
  /** Product is expressed in amount */
  Unit = 'unit',
  /** Product/Price is per kilogram */
  Kg = 'kg',
  /** Product/Price is per liter */
  Liter = 'liter'
}

/** Data for updating an existing customer. */
export type UpdateCustomerInputObjectType = {
  /**
   * External id used for linking an internal customer to an external datasource,
   * usually this is the e-commerce or ERP system used by the company.
   */
  externalId?: Maybe<Scalars['String']>;
  /** A dedicated 5 character numeric pincode for the customer, so they can always pickup their order using the same pincode. */
  pincode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Scalars['String']>>;
  phonenumbers?: Maybe<Array<Scalars['PhoneNumber']>>;
  language?: Maybe<LanguageEnum>;
};

/** Data that can be updated on the locker */
export type UpdateLockerInputObjectType = {
  temperatureType?: Maybe<LockerTemperatureTypeEnum>;
  boxCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** Object describing an order. */
export type UpdateOrderInputObjectType = {
  /** Preferred language of the customer */
  language: LanguageEnum;
  /** First Name of the customer */
  firstName: Scalars['String'];
  /** Last Name of the customer */
  lastName: Scalars['String'];
  /** E-Mail of the customer */
  emails: Array<Scalars['String']>;
  /** Customer this order is linked to. */
  customerId?: Maybe<Scalars['ObjectId']>;
};

/** Reservation data that can be updated. */
export type UpdateReservationInputObjectType = {
  /** The time the reservation is planned for pickup */
  pickupDateTime: Scalars['DateTime'];
  /** An optional external id to identify the order, mainly used for integrating with 3rd party platforms */
  externalOrderId?: Maybe<Scalars['String']>;
  /** An optional id pointing to a linked order */
  orderId?: Maybe<Scalars['ObjectId']>;
  /** A 4 character numeric pincode used for opening the locker at pickup */
  pincode?: Maybe<Scalars['String']>;
  /** If true and the reservation has been picked up this locker will remain reserved untill manually completed. */
  noAutoComplete?: Scalars['Boolean'];
  /** If true and the reservation has reach the configured time before pickup, we will automatically send a notification. */
  automaticallySendNotification?: Scalars['Boolean'];
  /** The notifications that should be dispatched x amount of time before pickup. */
  notificationTypes?: Array<Maybe<NotificationTypeEnumType>>;
  /** Information about the reservation, this is usually a description of the content. */
  extraInformation?: Maybe<Scalars['String']>;
  /**
   * The internal id of the customer this reservation belongs to. If none is
   * provided, contact information is required and we will automatically try to
   * link a customer using this information or create one if there is none.
   */
  customerId?: Maybe<Scalars['ObjectId']>;
  /** The first name of the customer, defaults to the customer first name if a customer id is provided. */
  firstName?: Maybe<Scalars['String']>;
  /** The last name of the customer, defaults to the customer last name if a customer id is provided. */
  lastName?: Maybe<Scalars['String']>;
  /** The emails of the customer, defaults to the customer email if a customer id is provided. */
  emails?: Maybe<Array<Scalars['String']>>;
  /** The phonenumbers of the customer, defaults to the customer phonenumber if a customer id is provided. */
  phonenumbers?: Maybe<Array<Scalars['PhoneNumber']>>;
  /** The preferred language of the customer */
  language?: LanguageEnum;
  /** A list of vending product items */
  vendingProducts?: Array<ProductCollectionItemInputObjectType>;
  /** A discount percentage to apply to the vending total price, ex 500 => 5% */
  vendingDiscount?: Maybe<Scalars['Int']>;
  /** The total price of the reservation for vending purposes */
  vendingTotalPrice?: Maybe<Scalars['Int']>;
  /** Is reservation a vending reservation */
  isVendingReservation?: Maybe<Scalars['Boolean']>;
  /** Should customer still pay this reservation, this will send a pay link to the customer when box gets reserved. */
  shouldCustomerPay?: Maybe<Scalars['Boolean']>;
  /** Does this reservation contain food. */
  canUseMealVouchers?: Maybe<Scalars['Boolean']>;
};

/** Values used to update reservation status. */
export type UpdateReservationStatusInputObjectType = {
  /** The new status for the reservation */
  status: ReservationStatusEnumType;
  /** The amount that has to be paid before receiving pincode. */
  orderAmount?: Maybe<Scalars['Int']>;
  /** Optional list of boxes, required when changing from created to reserved */
  boxes?: Maybe<Array<BoxReservationInputObjectType>>;
};

/** A token with all the data required to upload a file to our storage bucket */
export type UploadRequestTokenObjectType = {
  __typename?: 'UploadRequestTokenObjectType';
  bucket: Scalars['String'];
  bucketUrl: Scalars['String'];
  key: Scalars['String'];
  policy: Scalars['String'];
  googDate: Scalars['String'];
  googCredential: Scalars['String'];
  googAlgorithm: Scalars['String'];
  googSignature: Scalars['String'];
};

/** Object that describes the current quota usage and limit */
export type UsageLedgerEntryObjectType = {
  __typename?: 'UsageLedgerEntryObjectType';
  _id: Scalars['ObjectId'];
  type: QuotaTypeEnumType;
  /** Used amount by the current log entry */
  amount: Scalars['Float'];
  /** Describes this log entry */
  description: Scalars['String'];
  /** Total usage when this log was created */
  usage: Scalars['Float'];
  /** User that created the log */
  userId?: Maybe<Scalars['String']>;
  /** Api Key that created this log */
  apiKeyId?: Maybe<Scalars['ObjectId']>;
  /** Date and time when this log gets removed */
  removeAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type UserObjectType = {
  __typename?: 'UserObjectType';
  _id: Scalars['ObjectId'];
  /** @deprecated Deprecated in favor of _id */
  uid: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  isPasswordLoginEnabled: Scalars['Boolean'];
  highestRole?: Maybe<UserRoleObjectType>;
  roles?: Maybe<Array<Maybe<UserRoleObjectType>>>;
  language: LanguageEnum;
  lastReadAnnouncementAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type UserPaginatedResultObjectType = {
  __typename?: 'UserPaginatedResultObjectType';
  /** Documents */
  docs: Array<UserObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};

export type UserPreferencesInputObjectType = {
  name?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageEnum>;
  isPasswordLoginEnabled?: Maybe<Scalars['Boolean']>;
};

export type UserRoleObjectType = {
  __typename?: 'UserRoleObjectType';
  _id: Scalars['ObjectId'];
  userId: Scalars['ObjectId'];
  role: Scalars['Int'];
  referenceId?: Maybe<Scalars['ObjectId']>;
  referenceType?: Maybe<UserRoleReferenceTypeEnum>;
  organisation?: Maybe<OrganisationObjectType>;
};

/** An enum that the type of reference in a user role */
export enum UserRoleReferenceTypeEnum {
  /** An organisation/customer of the viresmo platform */
  Organisation = 'Organisation',
  /** A dealer of the viresmo platform */
  Dealer = 'Dealer',
  /** A reseller of the viresmo platform */
  Reseller = 'Reseller'
}

/** WooCommerce integration details. */
export type WooCommerceIntegrationObjectType = {
  __typename?: 'WooCommerceIntegrationObjectType';
  /** An internal id used within the platform */
  _id: Scalars['ObjectId'];
  shopId: Scalars['ObjectId'];
  apiUrl: Scalars['String'];
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

/** Information about an organisation. */
export type WoytiOrganisationObjectType = {
  __typename?: 'WoytiOrganisationObjectType';
  _id: Scalars['ObjectId'];
  /** External id used to identify viresmo organisations, this id gets put on invoices */
  id: Scalars['Int'];
  name: Scalars['String'];
  email: Scalars['String'];
  phonenumber: Scalars['PhoneNumber'];
  companyName: Scalars['String'];
  registrationNumber: Scalars['String'];
  vatNumber: Scalars['String'];
  address: AddressObjectType;
  language: LanguageEnum;
  brandColor: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  pathname: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type WoytiPreferences = {
  __typename?: 'WoytiPreferences';
  _id: Scalars['ObjectId'];
  clientId: Scalars['String'];
  notificationToken?: Maybe<Scalars['String']>;
  favoriteShops: Array<Scalars['ObjectId']>;
  locale: Scalars['String'];
  lastNotificationAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type WoytiPreferencesInput = {
  clientId: Scalars['String'];
  notificationToken?: Maybe<Scalars['String']>;
  favoriteShops: Array<Scalars['ObjectId']>;
  locale: Scalars['String'];
};

export type WoytiReservationObjectType = {
  __typename?: 'WoytiReservationObjectType';
  /** An internal id used within the platform */
  _id: Scalars['ObjectId'];
  /** A sequential numeric id, mainly used for visual purposes */
  id: Scalars['Int'];
  /** Current status of the reservation */
  status: ReservationStatusEnumType;
  /** A list of vending product items */
  vendingProducts: Array<ProductCollectionItemObjectType>;
  /** A discount percentage to apply to the vending total price, ex 500 => 5% */
  vendingDiscount?: Maybe<Scalars['Int']>;
  /** The total price of the reservation for vending purposes */
  vendingTotalPrice?: Maybe<Scalars['Int']>;
  /** Is reservation a vending reservation */
  isVendingReservation: Scalars['Boolean'];
  shopId: Scalars['ObjectId'];
  shop?: Maybe<WoytiShopObjectType>;
  /** Last time the status has been updated */
  updatedStatusAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

/** Woyti Shop */
export type WoytiShopObjectType = {
  __typename?: 'WoytiShopObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId'];
  /** Name of the service location */
  name: Scalars['String'];
  /** Phone number that gets used for supporting your customers */
  phonenumber: Scalars['PhoneNumber'];
  /** Email that gets used for supporting your customers */
  email: Scalars['String'];
  /** The location of the service location by address */
  address: AddressObjectType;
  /** The amount of hours a customer has to pickup an order when ordering from the vending machine */
  vendingPickupTime: Scalars['Int'];
  /** If this is true, the shop will not be shown in the virtual vending overview page */
  hideVirtualVendingInOverview: Scalars['Boolean'];
  /** Amount of vending reservations currently available for this shop */
  woytiReservationsCount: Scalars['Int'];
  /** url to the webshop of this shop */
  webshopUrl: Scalars['String'];
  /** Internal id used for linking to the organisation */
  organisationId: Scalars['ObjectId'];
  /** Organisation this shop belongs to */
  organisation: WoytiOrganisationObjectType;
  updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
};

export type WoytiShopPaginatedResultObjectType = {
  __typename?: 'WoytiShopPaginatedResultObjectType';
  /** Documents */
  docs: Array<WoytiShopObjectType>;
  /** The amount of items in the response */
  count: Scalars['Int'];
  /** The total amount of documents that match your query */
  total: Scalars['Int'];
  /** The defined limit value */
  limit: Scalars['Int'];
  /** The defined skip value */
  skip: Scalars['Int'];
};
